/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { combineReducers, configureStore } from '@reduxjs/toolkit';

import { sarsaparillaReducers } from 'sarsaparilla';
import { authReducers } from 'shared-ui/auth/redux';

import contactReducer from '../reducers/contactReducer';

const rootReducer = combineReducers({
    ...sarsaparillaReducers,

    // Auth - MUST COME AFTER SARSA REDUCERS DURING AUTH MIGRATION
    ...authReducers,
    navigation: combineReducers({
        contact: contactReducer,
    }),
});

export function setupStore(preloadedState?: any) {
    return configureStore({
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({ serializableCheck: false }), // temporary because of LD hack
        reducer: rootReducer,
        preloadedState,
    });
}

export const store = setupStore();

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
